export default `
    ... on ds_Navigation_GlobalSet {
        mainNav_LogoPosition
        mainNav_PageLinksPosition
        mainNav_ColorTheme
        mainNav_ColorPalette
        mainNav_ApplyHeadingFontMenuItems
        mainNav_ShowBackground
        mainNav_Quicklinks {
            ... on ds_MainNavQuicklinksItem_Entry {
                mainNavQuicklinksItem_Heading
                mainNavQuicklinksItem_Links {
                    url
                    text
                    target
                    ariaLabel
                    ... on mainNavQuicklinksItem_Links_Custom_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                    ... on mainNavQuicklinksItem_Links_Entry_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                    ... on mainNavQuicklinksItem_Links_Url_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                    ... on mainNavQuicklinksItem_Links_Phone_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                    ... on mainNavQuicklinksItem_Links_Email_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                }
            }
        }
        mainNav_Buttons {
            text
            url
            target
            ariaLabel
            isEmpty
            ... on mainNav_Buttons_Entry_LinkType {
                buttonStyle
            }
            ... on mainNav_Buttons_Custom_LinkType {
                buttonStyle
            }
            ... on mainNav_Buttons_Email_LinkType {
                buttonStyle
            }
            ... on mainNav_Buttons_Phone_LinkType {
                buttonStyle
            }
            ... on mainNav_Buttons_Url_LinkType {
                buttonStyle
            }
        }
        mainNav_Watermark {
            id
            url
        }
        secondaryNav_Type
        secondaryNav_ColorTheme
        secondaryNav_ColorPalette
        secondaryNav_Buttons {
            title
            text
            target
            ariaLabel
            url
            ... on secondaryNav_Buttons_Custom_LinkType {
                icon {
                    name
                    set
                    type
                }
            }
            ... on secondaryNav_Buttons_Entry_LinkType {
                icon {
                    name
                    set
                    type
                }
            }
            ... on secondaryNav_Buttons_Url_LinkType {
                icon {
                    name
                    set
                    type
                }
            }
            ... on secondaryNav_Buttons_Phone_LinkType {
                icon {
                    name
                    set
                    type
                }
            }
            ... on secondaryNav_Buttons_Email_LinkType {
                icon {
                    name
                    set
                    type
                }
            }
        }
    }
`